import Dropzone from 'dropzone';
import $ from "jquery";

Dropzone.options.dropzoneDemo = {
    maxFilesize   : 3, // MB
    error         : function (file, message) {
        $(file.previewElement).addClass("dz-error").find('.dz-error-message').text(message.errors ? message.errors.file[0] : null);
    },
    addRemoveLinks: true,
    maxFiles      : 1,
    init          : function () {
        this.on("maxfilesexceeded", function (file) {
            this.removeAllFiles();
            this.addFile(file);
        });
    }
};
window.currentCurrency = null;

function updateSelectedInvoices(_this) {
    let parent          = _this.parents('#invoices_table');
    let checkedElememts = parent.find('[name="invoices[]"]:checked');
    let checked         = checkedElememts.length;
    let span            = parent.find('th.checked > span');
    let payBtn = $('.pay-btn');
    let payNowOverlay = $('#pay_now_overlay');
    span.text(checked + span.data('text'));
    let payInvoiceCount = $('.pay-invoice-count');
    let payInvoiceSum = $('.pay-invoice-sum');
    let payInvoiceCurrency = $('.pay-invoice-currency');

    if (checked) {
        if (!window.currentCurrency) {
            window.currentCurrency = _this.data('currency');
            let disabledCheckbox = $(".invoice-checkbox").not("[data-currency='" + window.currentCurrency +"']");
            disabledCheckbox.attr('disabled', true);
            disabledCheckbox.parents('.table-row').addClass('disabled');
        }
        payInvoiceCount.text(checked)
        payInvoiceCurrency.text(_this.data('currency-sign'))
        let invoiceSum          = parseFloat(payInvoiceSum.text()) + parseFloat(_this.data('order-sum'));
        let invoiceSumFormatted =  window.priceFormat(invoiceSum)
        payInvoiceSum.text(invoiceSumFormatted)
        span.show();
        payBtn.show();
        payNowOverlay.show();
    } else {
        let disabledCheckbox = $(".invoice-checkbox").not("[data-currency='" + window.currentCurrency +"']");
        disabledCheckbox.attr('disabled', false);
        disabledCheckbox.parents('.table-row').removeClass('disabled');
        span.text(checked + span.data('text'));
        payInvoiceCount.val(checked);
        window.currentCurrency = null;
        payInvoiceSum.text(0);
        span.hide();
        payBtn.hide();
        payNowOverlay.hide();
    }
}

$(document).ready(function () {
    $('#submitbutton').on('click', function () {
        $('#accountform').submit();
    });
    $('#orders_table').DataTable({
        "ajax"      : $('#orders_table').attr('data-route'),
        "order"     : [[0, "desc"]],
        "processing": true,
        "serverSide": true,
        columns: [
            { data: 'order_id'},
            { data: 'buy_date'},
            { data: 'full_name', orderable: false,},
            {
                data: 'concept',
                orderable: false,
            },
            { data: 'agent_reference'},
            { data: 'total'},
        ],
        columnDefs: [
            {
                targets: -1,
                className: 'text-right'
            }
        ]
    });

    let invoiceTable =  $('.invoices-table').DataTable({
        "order"     : [[7, "asc"]],
        "processing": true,
        "serverSide": true,
        columns: [
            { data: 'checkbox', orderable: false},
            { data: 'invoice_number'},
            { data: 'total'},
            { data: 'full_name', orderable: false},
            { data: 'agent_reference', orderable: false},
            { data: 'status', orderable: false},
            { data: 'due_on_date'},
            { data: 'buy_date'},
        ],
        columnDefs: [
            {
                targets: 1,
                className: 'text-right'
            }
        ]
    });
    invoiceTable.on('draw', function (e) {
        updateSelectedInvoices($('#' + e.target.id));
    });

    $(document).on('click', '[name="invoices[]"]', function () {
        updateSelectedInvoices($(this));
    });

    $('#pay_now_overlay').on('click', function () {
        let form = $('#account-invoices-payment-form');
        let invoices = [];
        let checkboxes = form.find('[name="invoices[]"]:checked');
        for(var item of checkboxes){
            invoices.push(item.value);
        }
        window.location.href = form.attr('action') + '?invoices=' + invoices.join();
    })

    $('.invoice-table-row').on('click', function (e) {
        if (!$(e.target).hasClass('invoice-label') && !$(e.target).hasClass('invoice-checkbox')) {
            window.location.href = $(this).data('href');
        }
    });

    $('.btn-copy-data').click(function() {
        const target = $(this).data('target');
        const all = $('#guest-form').serializeArray();
        const targetIndex = all.findIndex((item) => {
            return item.name === 'guests[' + target + '][id]';
        });

        if (targetIndex === -1) {
            return;
        }


        let realTarget;
        for (let a= targetIndex - 1; a >= 0; a--) {
            if (all[a].name.match(/guests\[[0-9]+-[0-9]+\]\[lead\]/) && all[a].value === '1') {
                realTarget = a;
                break;
            }
        }

        const source = all[realTarget].name.replace(/guests\[([0-9]+-[0-9]+)\].+/,"$1");
        all.forEach((item) => {
            const reg = new RegExp("guests\\[" + source + "\\]");
            if (item.name.match(reg) && !item.name.match('\\[id\\]') && !item.name.match('\\[type\\]') && !item.name.match('\\[lead\\]')) {
                $('[name="' + item.name.replace('[' + source + ']', '[' + target +']')  + '"]').val($('[name="' + item.name  + '"]').val())
            }
        });
    });


    $('#generate-api-key-btn').on('click', function() {
        if ($('#api-key-name').val().length < 1) {
            return;
        }
        let button = $(this);
        button.prop('disabled', true);
        $.ajax({
            type: 'POST',
            dataType: 'json',
            url: '/account/api-keys',
            data: {name: $('#api-key-name').val()},
            success: function (data) {
                $('#generate-api-key-modal').modal('hide');
                $('#show-api-key-value').append(data.apiKey);
                $('#show-api-key-modal').modal('show');
                button.prop('disabled', false);
                $('#api-key-name').val('');
            }
        });
    });
    $('#show-api-key-close').on('click', function() {
        window.location.reload();
    });

    $('.revoke-api-key-btn').on('click', function() {
        $.ajax({
            type: 'DELETE',
            dataType: 'json',
            url: `/account/api-keys/${$(this).data('id')}`,
            success: function (data) {
                window.location.reload();
            }
        });

    });
    $('#revoke-api-key-btn').on('click', function() {
        let button = $(this);
        $.ajax({
            type: 'DELETE',
            dataType: 'json',
            url: `/account/api-keys/${button.data('id')}`,
            success: function (data) {
                window.location.reload();
            }
        });



    });

});
